 $(document).ready(function(){
var swiper = new Swiper(".itg_featured_collection_slider", {
  slidesPerView: 4,
  autoplay:false,
  loop: false,
  spaceBetween: 30,
  scrollbar: {
    el: ".itg_tabfeatured_scrollbar",
    hide: false,
    draggable: true,
    dragSize:400
  },
  breakpoints: {
    1025: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
       scrollbar: {
    el: ".itg_tabfeatured_scrollbar",
    hide: false,
    draggable: true,
    dragSize:200
  }
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
     480: {
      slidesPerView: 2,
      spaceBetween: 20,
         scrollbar: {
    el: ".itg_tabfeatured_scrollbar",
    hide: false,
    draggable: true,
    dragSize:100
  }
    },
    320: {
      slidesPerView: 2,
      spaceBetween: 20,
        scrollbar: {
    el: ".itg_tabfeatured_scrollbar",
    hide: false,
    draggable: true,
    dragSize:100
  }
    }
  },
});
   
  var swiper = new Swiper(".DstBannercolslider", {
   spaceBetween: 30,
   // centeredSlides: true,
  autoplay:true,
  speed: 1000,
  loop: true,
  slidesPerView:'4',
  allowTouchMove: false,
  disableOnInteraction: true,
   autoplay: {
    delay: 1,
    pauseOnMouseEnter: true,
  },
      breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 2
    },
    // when window width is >= 640px
    770: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 4
    }
  } 
});
$(".DstBannercolslider").hover(function() {
    (this).swiper.autoplay.stop();
}, function() {
    (this).swiper.autoplay.start();
});


   
});

// testimonial

 $(document).ready(function(){
     var swiper = new Swiper(".cstm_testimonial", {
      slidesPerView: 3,
      grabCursor: true, 
      observer: true,
      spaceBetween: 30,
      observeParents: true,
      scrollbar: {
        el: ".cst_testimonial",
        hide: false,
        draggable: true,
        dragSize:400
      },
      navigation: {
        nextEl: '.swiper-button-next.argolf-bestsellers',
        prevEl: '.swiper-button-prev.argolf-bestsellers',
      }, 
    breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
          scrollbar: {
        el: ".cst_testimonial",
        hide: false,
        draggable: true,
        dragSize:200
      },
      navigation: {
        nextEl: '.swiper-button-next.argolf-bestsellers',
        prevEl: '.swiper-button-prev.argolf-bestsellers',
      }
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 2,
          scrollbar: {
        el: ".cst_testimonial",
        hide: false,
        draggable: true,
        dragSize:200
      },
      navigation: {
        nextEl: '.swiper-button-next.argolf-bestsellers',
        prevEl: '.swiper-button-prev.argolf-bestsellers',
      }
    },
    // when window width is >= 640px
    770: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 3
    }
  } 
  });
});



